module.exports = __webpack_public_path__ + "img/portraits_05_V.fa4a9ab6.webp";